module.exports = __webpack_public_path__ + "static/media/succes.1068a0c.wav";